import { render, staticRenderFns } from "./CascadingCardScaleSelect.vue?vue&type=template&id=990ced80"
import script from "./CascadingCardScaleSelect.vue?vue&type=script&lang=js"
export * from "./CascadingCardScaleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports